module.exports = function Worker_fn() {
  return new Worker(__webpack_public_path__ + "clustering-gql.worker.dc6eb3051a0630fd9c92.worker.js");
}
